import React from 'react'
import { Link } from '../../../../utils/link'
import { locationBlockClasses } from '../../../../utils/style'
import { getClassName } from '../../../../utils/utils'
import { useInView } from '../../../hooks/useInView'
import { Location } from '../../cmsPageState'
import { LocationBlock } from '../blocksState'

export type LocationBlockStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  headerClassName: string
  titleClassName: string
  contentClassName: string
  listClassName: string
  itemClassName: string
  linkClassName: string
  linkLabelClassName: string
  linkDateClassName: string
  linkReadMoreClassName: string
}>

//This function takes in the base google maps url, along with an address.
//It will then modify the google maps url to point to the given address.
function generateGoogleMapsUrl(base: string, address?: string, postal?: string, title?: string): string {
  //WARNING - If the page suddenly gives a type error, it likely means that you did not parse the URL correctly.
  let mapsurl: string = base
  //this should be enough info to pinpoint a location on google...
  mapsurl += `/${address}+${postal},+${title}`
  return mapsurl
}

export const LocationBlockLayout = (props: LocationBlock & { location?: Location }) => {
  const { index, inview, location } = props
  const classes = locationBlockClasses
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("LocationBlockLayout inView:", inview),
    !inview?.triggerOnce
  )
  return (
    <section
      key={`block-${index}`}
      id={`io-${index}`}
      ref={ref}
      className={getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')}
    >
      {location && (
        <div className="block__inner container--m gutter--m">
          <div className="block__wrapper section--bg-secondary">
            <div className="block__content">
              {(location.openingTimes || location.openingTimesPolyclinic || location.visitingTimes) && (
                <section className="block__section">
                  <h2 className="block__title title--l">Openingstijden en bezoekuren</h2>
                  {location.openingTimes && (
                    <div className="block__item">
                      <h3 className="block__subtitle title--m">Openingstijden</h3>
                      <p>{location.openingTimes}</p>
                    </div>
                  )}
                  {location.openingTimesPolyclinic && (
                    <div className="block__item">
                      <h3 className="block__subtitle title--m">Openingstijden poliklinieken</h3>
                      <p>{location.openingTimesPolyclinic}</p>
                    </div>
                  )}
                  {
                    <div className="block__item">
                      <h3 className="block__subtitle title--m">Bezoekuren</h3>
                      <p>
                        Bekijk de{' '}
                        <a href="/ik-wil-op-bezoek-komen/bezoektijden" className="link--styled">
                          actuele bezoektijden
                        </a>
                        .
                      </p>
                    </div>
                  }
                </section>
              )}
              {(location.address || location.postalAddress || location.email) && (
                <section className="block__section">
                  <h2 className="block__title tistle--l">Informatie over deze locatie</h2>
                  {location.address && (
                    <div className="block__item">
                      <p>{location.address}</p>
                    </div>
                  )}
                  {location.postalAddress && (
                    <div className="block__item">
                      <h3 className="block__subtitle title--m">Postadres</h3>
                      <p>{location.postalAddress}</p>
                    </div>
                  )}

                  {location.email && (
                    <div className="block__clickable">
                      <a href={`mailto:${location.email}`} className="link--styled">
                        {location.email}
                      </a>
                    </div>
                  )}

                  <div className="block__clickable">
                    {/* Google Maps link for in the Location Block. Compines address and title parameters to form a search query.
                        Should be used for Spaarne Gasthuis locations.  */}
                    <Link
                      url={generateGoogleMapsUrl(
                        'http://google.com/maps/search',
                        location.address,
                        location.title,
                        'Spaarne Gasthuis'
                      )}
                      className="button--primary"
                    >
                      <span className="button__label">Bekijk de locatie op Google Maps</span>
                    </Link>
                  </div>
                </section>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  )
}
